import { AzureADServicePrincipalSummaryModel } from '../../../microsoft/azuread/profile/azure-adservice-principal-summary-model';
import { AzureADServicePrincipalSummaryWithScopesModel } from '../../../microsoft/azuread/profile/azure-adservice-principal-summary-with-scopes-model';
import { AzureADUserSummaryModel } from '../../../microsoft/azuread/profile/azure-aduser-summary-model';

export class AzureADAppPermissionGrantModel {
  client: AzureADServicePrincipalSummaryModel;
  user: AzureADUserSummaryModel;
  resources: AzureADServicePrincipalSummaryWithScopesModel[];
}
